import { styled } from "@mui/material/styles";
import { Typography, Box, Button, Card } from "@mui/material";
import Color from "../../theme/Colours";
import colors from "../../theme/Colours";

export const Title = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontFamily: "Montserrat",
  fontSize: "17.8px",
  color: Color.headerTextColor,
  marginTop: theme.spacing(2),
}));

export const Label = styled(Typography)(() => ({
  fontWeight: 600,
  fontFamily: "Roboto",
  fontSize: "14px",
  marginBottom: 7,
  color: Color.defaultFontColor,
}));

export const StyledCard = styled(Card)({
  padding: 20,
  borderRadius: 0,
  boxShadow: "none",
});

export const ButtonStyle = styled(Button)({
  boxShadow: "none",
  borderRadius: 8,
  "&.MuiButton-outlined": {
    border: `1px solid ${Color.primaryButtonOrange}`,
    backgroundColor: "transparent",
    color: Color.primaryButtonOrange,
    "&:hover": {
      backgroundColor: Color.primaryButtonOrange,
      color: Color.background2,
      boxShadow: "none",
    },
  },
  "&.MuiButton-contained": {
    backgroundColor: Color.primaryButtonOrange,
    color: Color.background2,
    border: "none",
    "&:hover": {
      backgroundColor: Color.primaryButtonOrangeHover,
      boxShadow: "none",
    },
  },
});

export const PaginationCaption = styled(Typography)({
  color: Color.greyTypography,
  display: "flex",
  alignItems: "center",
});

export const PaginationControlBox = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  marginTop: 24,
  alignItems: "center",
});

export const NameStyle = styled(Typography)({
  color: colors.linkColor,
});
